import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __, _i } from "../../utils";
import { useStores } from "../../store";
import { useLocation } from "react-router-dom";
import { getManagerDependingVariables } from "@devowl-wp/cookie-consent-web-client";
const NoticeNoManager = observer(()=>{
    const { optionStore: { setCookiesViaManager, createdTagManagers, isGcm } } = useStores();
    const { managerLabel, expectedManagerPresetId } = getManagerDependingVariables(setCookiesViaManager, {
        isGcm,
        presetId: ""
    });
    const { pathname } = useLocation();
    return managerLabel && !createdTagManagers[expectedManagerPresetId].length && /^\/cookies\/\d+$/.test(pathname) && /*#__PURE__*/ _jsx("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: {
            margin: "10px 0 0 0"
        },
        children: /*#__PURE__*/ _jsxs("p", {
            children: [
                _i(__("You have not yet defined a %s service. To use {{strong}}%s{{/strong}} with Real Cookie Banner, you must create the appropriate service.", managerLabel, managerLabel), {
                    strong: /*#__PURE__*/ _jsx("strong", {})
                }),
                " ",
                "• ",
                /*#__PURE__*/ _jsx("a", {
                    href: `#${pathname}/new?force=${expectedManagerPresetId}`,
                    children: __("Create now")
                })
            ]
        })
    });
});
export { NoticeNoManager };
